module.exports = __webpack_public_path__ + "img/cliff-sides-shadow.dffd2547.png";